import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Logo from "@/components/Logo";
import SoftwareHero from "./SoftwareHero";

export default function AuthShell({ children, title, subtitle, showQuickNav = false }) {
  return (
    <div className="h-screen grid grid-cols-1 lg:grid-cols-[58%_42%] bg-white">

      {/* LEFT PANEL */}
      <div className="hidden lg:flex h-full flex-col overflow-auto">
        <SoftwareHero />
      </div>

      {/* RIGHT PANEL */}
      <div className="relative flex w-full h-full items-center justify-center bg-white px-8 py-10">

        {showQuickNav ? (
          <div className="absolute top-14 left-0 right-0 flex items-center justify-between px-12">
            <HashLink
              smooth
              to="/login#available-modules"
              className="rounded-full border border-gray-200 bg-white px-6 py-3 text-base font-semibold text-gray-700 shadow-sm transition-all hover:border-[#0B6936] hover:bg-[#F7FBF4] hover:text-[#0B6936]"
            >
              Available Modules
            </HashLink>

            <HashLink
              smooth
              to="/login#contact"
              className="rounded-full border border-gray-200 bg-white px-6 py-3 text-base font-semibold text-gray-700 shadow-sm transition-all hover:border-[#0B6936] hover:bg-[#F7FBF4] hover:text-[#0B6936]"
            >
              Contact Us
            </HashLink>
          </div>
        ) : null}

        <div className="w-full max-w-md">

          <div className="mb-8 lg:hidden">
            <Link to="/">
              <Logo />
            </Link>
          </div>

          <h1 className="font-display text-3xl font-bold tracking-tight text-gray-900">
            {title}
          </h1>

          {subtitle && (
            <p className="mt-2 text-sm text-gray-600">
              {subtitle}
            </p>
          )}

          <div className="mt-8">
            {children}
          </div>
        </div>
      </div>

    </div>
  );
}